import { useCallback } from 'react';
import { Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useReleaseValidation } from 'pages/Distribution/hooks';
import { locations } from 'services/routes/locations';
import {
  ReleaseTitle,
  ArtistName,
  CoverArtSection,
  GenreSelector,
} from './components';
import { ButtonContainer, GoBackButton, ContinueButton } from './styled';

type PropsType = {
  releaseId: string;
};

const ReleaseInfo = ({ releaseId }: PropsType) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { isValid } = useReleaseValidation(releaseId);

  const handleGoBack = useCallback(
    () => navigate(locations.distribution.tracklist.pathname(releaseId)),
    [releaseId, navigate]
  );

  const handleGoToReview = useCallback(
    () => navigate(locations.distribution.review.pathname(releaseId)),
    [releaseId, navigate]
  );

  return (
    <Stack spacing={3}>
      <ArtistName releaseId={releaseId} />
      <ReleaseTitle releaseId={releaseId} />
      <GenreSelector releaseId={releaseId} />
      <CoverArtSection releaseId={releaseId} />
      <ButtonContainer>
        <GoBackButton onClick={handleGoBack}>
          {t('distribution:details:actions:goBack')}
        </GoBackButton>
        <ContinueButton disabled={!isValid} onClick={handleGoToReview}>
          {t('distribution:details:actions:continue')}
        </ContinueButton>
      </ButtonContainer>
    </Stack>
  );
};

export default ReleaseInfo;
